var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "eitsz3dhva",
    d: "M0 0.334L476.449 0.334 476.449 432 0 432z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eh8no8horc",
    d: "M0 432.667L476.449 432.667 476.449 1 0 1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.5 58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7CD9C2",
    d: "M136.746 360.151c-5.353 0-10.705-2.042-14.789-6.126-8.168-8.167-8.168-21.41 0-29.577l59.02-59.02-59.02-59.022c-8.168-8.168-8.167-21.41 0-29.578 8.168-8.167 21.411-8.168 29.58.001l73.808 73.81c8.168 8.167 8.168 21.41 0 29.577l-73.81 73.81c-4.084 4.083-9.436 6.125-14.789 6.125M372.078 357.614h-98.267c-11.55 0-20.915-9.363-20.915-20.915 0-11.55 9.364-20.915 20.915-20.915h98.267c11.551 0 20.914 9.364 20.914 20.915 0 11.552-9.363 20.915-20.914 20.915"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jy46tfdryb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eitsz3dhva"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M47.13 17.334C29.953 17.334 17 30.003 17 46.803V385.53C17 401.78 29.184 415 44.158 415H432.29c14.976 0 27.159-13.22 27.159-29.47V46.803c0-16.866-12.77-29.47-24.187-29.47H47.13zM432.29 432H44.158C19.81 432 0 411.154 0 385.53V46.804C0 20.312 20.262.333 47.13.333h388.132c21.94 0 41.187 21.715 41.187 46.47V385.53c0 25.623-19.81 46.47-44.16 46.47z",
    mask: "url(#jy46tfdryb)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mk18wtvtld",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eh8no8horc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M4.289 104.869L476.177 104.869 476.177 87.869 4.289 87.869zM143.12 61.069H43.843c-4.97 0-9-4.03-9-9 0-4.971 4.03-9 9-9h99.275c4.971 0 9 4.029 9 9 0 4.97-4.029 9-9 9M310.535 61.069h-18.298c-4.97 0-9-4.03-9-9 0-4.971 4.03-9 9-9h18.298c4.971 0 9 4.029 9 9 0 4.97-4.029 9-9 9M366.258 60.62h-18.86c-4.97 0-9-4.029-9-9 0-4.97 4.03-9 9-9h18.86c4.97 0 9 4.03 9 9 0 4.971-4.03 9-9 9M422.177 60.62h-18.86c-4.97 0-9-4.029-9-9 0-4.97 4.03-9 9-9h18.86c4.97 0 9 4.03 9 9 0 4.971-4.03 9-9 9",
    mask: "url(#mk18wtvtld)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnix);
export default __webpack_public_path__ + "static/media/icon--unix.395417419bb2cebf555289f964dbf9b4.svg";
export { ForwardRef as ReactComponent };